package kz.dentalcrm.app.data.network.response_model.protocol_templates

import kotlinx.serialization.Serializable

@Serializable
data class TreatmentDetailResponseItem(
    val id: Int,
    val name: String,
    val options: List<Option>
)